<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col cols="10">
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.criteria.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="accStatusList"
            v-model="queryParam.criteria.accStatus"
          ></b-form-select>
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="invStatusList"
            v-model="queryParam.criteria.invStatus"
          ></b-form-select>
          <b-form-select
            style="min-width:120px;"
            class="m-1"
            :options="invTypeList"
            v-model="queryParam.criteria.invTypeCode"
          ></b-form-select>
          <b-form-select
            style="min-width:130px;"
            class="m-1"
            :options="entList"
            v-model="queryParam.criteria.buyerTaxCode"
          ></b-form-select>

          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="开票方/发票号码"
            v-model="queryParam.criteria.keyword"
          ></b-form-input>

          <date-range-picker
            ref="picker"
            opens="center"
            :locale-data="{ locale: daterange.local, format: 'yyyy-MM-dd' ,applyLabel:'确定',cancelLabel:'取消'}"
            :ranges="daterange.ranges"
            v-model="queryParam.criteria.daterange"
            style="min-width:200px;"
            placeholder="创建日期"
            class="m-1"
          ></date-range-picker>

          <b-button variant="outline-primary" @click="list(1)" class="m-1">查询</b-button>
          <!-- <json-excel :fields="excel.fields" :fetch="exportData" :name="excel.name" type="xls">
            <b-button variant="primary" class="ml-3">导出</b-button>
          </json-excel>-->
        </b-form>
      </b-col>
      <b-col cols="2">
        <b-dropdown class="m-1 float-right" left text="导出" variant="primary">
          <b-dropdown-item @click="handleExportCsv">发票数据</b-dropdown-item>
          <b-dropdown-item @click="handleExportLinesCsv">发票明细</b-dropdown-item>
          <b-dropdown-item @click="handleExportDoc()">版式文件批量导出</b-dropdown-item>
        </b-dropdown>
        <b-button class="m-1 float-right" variant="primary" to="invoice/olap">多维分析</b-button>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"

      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(accStatus)="data">
          <b-badge variant="secondary" v-if="data.value=='0'">未入账</b-badge>
          <b-badge variant="success" v-if="data.value=='1'">已入账</b-badge>
          <b-badge variant="primary" v-if="data.item.status=='0'" class="ml-1">正常</b-badge>
          <b-badge variant="danger" v-if="data.item.status !='0'" class="ml-1">异常</b-badge>
          <b-badge variant="warning" class="ml-1">{{getInvTypeName(data.item.cataCode)}}</b-badge>
        </template>

        <template v-slot:cell(invCode)="data">
          <b-link @click="handleView(data.item)">{{data.item.invCode+'-'+data.item.invNo}}</b-link>
        </template>

        <template v-slot:cell(fileSubmitter)="data">
          <span
            v-if="data.item.fileSubmitterName != null && data.item.fileSubmitterName != data.item.fileSubmitter"
          >{{data.item.fileSubmitterName}}&lt;{{data.item.fileSubmitter}}&gt;</span>
          <span
            v-if="data.item.fileSubmitterName != null && data.item.fileSubmitterName == data.item.fileSubmitter"
          >{{data.item.fileSubmitterName}}</span>
          <span v-if="data.item.fileSubmitterName == null">{{data.item.fileSubmitter}}</span>
        </template>

        <template v-slot:cell(actions)="row">
          <b-dropdown size="sm" class="m-2" variant="link" toggle-class="text-decoration-none" >
            <template #button-content>
              <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
            </template>
            <b-dropdown-item-button @click="handleView(row.item)">查看</b-dropdown-item-button>
            <b-dropdown-item-button @click="download(row.item.id)">下载</b-dropdown-item-button>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button @click="openExpenseDialog(row.item)" v-if="row.item.expenseStatus=='0' && row.item.accStatus=='0'">报销</b-dropdown-item-button>
            <b-dropdown-item-button @click="handleCancelExpense(row.item)" v-if="row.item.expenseStatus=='1' && row.item.accStatus=='0'">取消报销</b-dropdown-item-button>
            <b-dropdown-item-button @click="openAccountDialog(row.item,'account')" v-if="row.item.accStatus=='0'">入账</b-dropdown-item-button>
            <b-dropdown-item-button @click="openAccountDialog(row.item,'unaccount')" v-if="row.item.accStatus=='1'">取消入账</b-dropdown-item-button>

          </b-dropdown>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>

    <b-modal
      id="accountModal"
      title="入账"
      incline
      v-model="accountDialogVisible"
      @ok="handleAccount('account')"
    >
      <template slot="modal-ok">入账</template>
      <template slot="modal-cancel">取消</template>

      <form ref="uploadParam">
        <b-form-group label="选择企业">
          <b-form-select
            style="min-width:130px;"
            :options="accEntList"
            v-model="accountParam.entCode"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="凭证编号">
          <b-form-input v-model="accountParam.voucherId" placeholder="请输入凭证编号"></b-form-input>
        </b-form-group>
        <b-form-group label="报销单编号">
          <b-form-input v-model="accountParam.expenseReportId" placeholder="请输入报销单编号"></b-form-input>
        </b-form-group>
        <b-form-group label="报销人">
          <b-form-input v-model="accountParam.expenseEmpName" placeholder="请输入报销人姓名"></b-form-input>
        </b-form-group>
        <b-form-group label="入账日期">
          <b-form-datepicker v-model="localAccTime" :value-as-date="true" locale="zh" class="mb-2"></b-form-datepicker>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal
      id="expenseModal"
      title="报销"
      incline
      v-model="expenseDialogVisible"
      @ok="handleExpense()"
    >
      <template slot="modal-ok">报销</template>
      <template slot="modal-cancel">取消</template>

      <form ref="uploadParam2">
        <b-form-group label="报销单编号">
          <b-form-input v-model="expenseParam.expenseReportId" placeholder="请输入报销单编号"></b-form-input>
        </b-form-group>
        <b-form-group label="报销人">
          <b-form-input v-model="expenseParam.expenseEmpName" placeholder="请输入报销人姓名"></b-form-input>
        </b-form-group>
        <b-form-group label="报销日期">
          <b-form-datepicker v-model="expenseParam.expenseTime" :value-as-date="true" locale="zh" class="mb-2"></b-form-datepicker>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import * as invoiceFacade from "../../../api/invoice-facade.js";
import * as invoiceDocFacade from "../../../api/invoice-doc-facade.js";
import * as accountFacade from "../../../api/account-facade.js";
import * as codeListFacade from "../../../api/code-list-facade.js";
import * as orgFacade from "../../../api/org-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import { mapState } from "vuex";
import { zhCN } from "date-fns/locale";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

//import dayjs from "dayjs";

export default {
  // validations:
  data() {
    return {
      orgList: [
        { text: "机构", value: "" },
        { text: "机构一", value: "1" }
      ],
      accStatusList: [
        { text: "入账状态", value: "" },
        { text: "未入账", value: "0" },
        { text: "已入账", value: "1" }
      ],
      invTypeList: [
        { text: "票种", value: "" },
        { text: "增值税电子普通发票", value: "10" },
        { text: "增值税电子专用发票", value: "20" },
        { text: "电子发票（增值税专用发票）", value: "31" },
        { text: "电子发票（普通发票）", value: "32" },
        { text: "电子发票（铁路电子客票）", value: "51" },
        { text: "电子发票（航空运输客票电子行程单）", value: "61" },
        { text: "纸质发票（增值税专用发票）", value: "85" },
        { text: "纸质发票（普通发票）", value: "86" },
        { text: "增值税专用发票", value: "01" },
        { text: "增值税普通发票", value: "04" }
      ],
      entList: [
        { text: "受票方", value: "" },
        { text: "客户一", value: "444444444" },
        { text: "客户二", value: "555555555" }
      ],
      accEntList: [],
      localAccTime: new Date(),
      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },

      fields: [
        {
          key: "accStatus",
          label: "状态",
          thClass: "blank"
        },

        {
          key: "orgName",
          label: "机构"
        },
        {
          key: "invCode",
          label: "发票代码-号码"
        },
        {
          key: "sellerName",
          label: "开票方"
        },
        {
          key: "buyerName",
          label: "受票方"
        },
        {
          key: "issueDate",
          label: "开票日期"
        },
        {
          key: "noTaxAmount",
          label: "不含税金额"
        },
        {
          key: "fileSubmitter",
          label: "提交人"
        },
        {
          key: "uploadTime",
          label: "提交时间"
        },
        {
          key: "expenseEmpName",
          label: "报销人"
        },
        {
          key: "expenseTime",
          label: "报销时间"
        },
        {
          key: "accUserName",
          label: "入账人"
        },
        {
          key: "accTime",
          label: "入账时间"
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          accStatus: "",
          invTypeCode: "",
          invStatus:"",
          buyerTaxCode: "",
          keyword: "",
          daterange: {
            startDate: addDays(new Date(), -90),
            endDate: new Date()
          },
          uploadDate: []
        },
        sortOrder: { createTime: "descending" }
      },
      //入账条件
      accountParam: {
        invoiceId: "",
        entCode: "",
        accTime: null
      },
      exportParam: {
        deviceNo: "",
        collectDate: []
      },
      expenseParam: {
        invoiceId: "",
        entCode: "",
        expenseTime: new Date()
      },

      excel: { data: [], fields: {}, name: "" },

      // 以上为数据展示和传输对象
      // 下拉列表
      invStatusList: [],

      // 以下为页面状态控制参数
      showOrg: false,
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      accountDialogVisible: false,
      expenseDialogVisible: false,
      // 以下为表单校验规则

      // 以上为表单校验规则
    };
  },
  watch: {
    "queryParam.criteria.orgId"() {
      if (this.queryParam.criteria.orgId) {
        entFacade
          .findByOrgId(this.queryParam.criteria.orgId)
          .then(res => {
            this.parseEntInfo(res);
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });
      }
    }
  },
  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    this.initInfo();
  },
  mounted() {
    // 异步加载列表数据

    this.handleQuery();
    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    // 异步加载列表数据
    list(page) {
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.uploadDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.uploadDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );
      }
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      invoiceFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    openAccountDialog(item, type) {
      let buyerTaxCode = item.buyerTaxCode;
      this.accountParam.invoiceId = item.id;
      if (type == "account") {
        this.accountParam.entCode = buyerTaxCode;
        // this.accountParam.voucherId = item.voucherId;
        if(item.expenseReportId != null){
          this.accountParam.expenseReportId = item.expenseReportId;
        }
        if(item.expenseEmpName != null){
          this.accountParam.expenseEmpName = item.expenseEmpName;
        }
        this.accountDialogVisible = true;
        return;
      }
      let typeStr = type == "account" ? "入账" : "取消入账";
      this.$bvModal
        .msgBoxConfirm("确认" + typeStr + "吗？", {
          title: typeStr,
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: typeStr,
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            type == "account"
              ? this.handleAccount()
              : this.handleCancelAccount();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //记账or取消记账动作执行
    handleAccount() {
      //记账
      this.pageLoading = true;
      this.localAccTime = addHours(this.localAccTime, 8);
      this.accountParam.accTime = this.localAccTime;
      accountFacade
        .accountByInvoiceId(this.accountParam)
        .then(() => {
          this.pageLoading = false;

          this.$message({
            message: "入账成功",
            type: "success"
          });
          this.list();
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
      this.accountParam.entCode = "";
      this.accountParam.invoiceId = "";
      this.localAccTime = new Date();
    },
    handleCancelAccount() {
      //记账

      this.pageLoading = true;
      accountFacade
        .cancelAccountByInvoiceId(this.accountParam.invoiceId)
        .then(() => {
          this.pageLoading = false;
          this.$message({
            message: "取消入账成功",
            type: "success"
          });
          this.list();
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
    },

    // 打开报销窗口
    openExpenseDialog(item){
      this.expenseDialogVisible = true;
      this.expenseParam.invoiceId = item.id;
      // this.expenseParam.expenseReportId = "";
      // this.expenseParam.expenseEmpName = "";
      this.expenseParam.expenseTime = new Date();
    },

    // 执行报销
    handleExpense(){
      this.pageLoading = true;
      console.log(this.expenseParam)
      accountFacade
        .expenseByInvoiceId(this.expenseParam)
        .then(() => {
          this.pageLoading = false;

          this.$message({
            message: "记录员工报销成功",
            type: "success"
          });
          this.list();
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
      this.expenseParam.invoiceId = "";
      // this.expenseParam.expenseReportId = "";
      // this.expenseParam.expenseEmpName = "";
      this.expenseParam.expenseTime = new Date();

    },

    // 取消报销
    handleCancelExpense(data){
      this.$bvModal
        .msgBoxConfirm("确认要撤销该发票的报销信息吗？", {
          title: "取消报销",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "确定",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            console.log("取消报销")
            accountFacade
              .cancelExpenseByInvoiceId(data.id)
              .then(() => {
                this.pageLoading = false;

                this.$message({
                  message: "取消报销成功",
                  type: "success"
                });
                this.list();
              })
              .catch(err => {
                this.pageLoading = false;
                console.log("err", err);
              });
              }
        })
        .catch(err => {
          console.log(err);
        });

    },

    //查看发票
    handleView(item) {
      if(item.fileFormat == null){
        const { href } = this.$router.resolve({
          name: "view",
          query: { c: item.id }
        });

        window.open(href, "_blank");

      }else{
        const { href } = this.$router.resolve({
          name: "viewer2",
          query: { id: item.id }
        });

        window.open(href, "_blank");
      }
    },

    // 执行查询操作
    handleQuery() {
      this.list();
    },

    // 执行csv导出
    handleExportCsv() {
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.uploadDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.uploadDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );
      }
      invoiceFacade
        .exportCsv(this.queryParam.criteria) // 异步调用后台接口
        .then(response => {
          console.log(response);
          let resdata = "\ufeff" + response;
          var blob = new Blob([resdata], { type: "text/csv,charset=gbk" });
          // if (response.headers['content-type'] === 'APPLICATION/OCTET-STREAM') {
          let filename = "invoice-list.csv";
          //response.data为下载的文件数据
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          // }
        });
    },

    // 执行csv导出
    handleExportLinesCsv() {
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.uploadDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.uploadDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );
      }
      invoiceFacade
        .exportLinesCsv(this.queryParam.criteria) // 异步调用后台接口
        .then(response => {
          console.log(response);
          let resdata = "\ufeff" + response;
          var blob = new Blob([resdata], { type: "text/csv,charset=gbk" });
          // if (response.headers['content-type'] === 'APPLICATION/OCTET-STREAM') {
          let filename = "invoice-list.csv";
          //response.data为下载的文件数据
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          // }
        });
    },

    // 执行档案导出
    handleExportDoc() {
      // this.queryParam.archive = this.;
      invoiceDocFacade
        .eidownloads(this.queryParam.criteria) // 异步调用后台接口
        .then(response => {
          this.$message({
            message: "发票版式批量下载任务提交成功,稍后请在批量导出管理中查看结果",
            type: "success"
          })
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });

    },

    download(id){
      var downloadUrl = process.env.VUE_APP_INVOICE_DOWNLOAD_PREFIX + id;
      window.open(downloadUrl, "_blank");

    },

    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];

          res.map(item => {
            let org = {};
            org.text = item.name;
            org.value = item.id;
            orgList.push(org);
          });
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //获取企业信息
    async getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUser()
        .then(res => {
          this.parseEntInfo(res);
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //初始化信息
    initInfo() {
      let roles = this.info.roles;
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        this.showOrg = true;
        this.getOrgInfo();
        this.getEntInfo();
      } else {
        //机构管理员或者财务经理
        this.showOrg = false;
        this.getEntInfo();
        // 表格中不显示机构信息
        this.fields.splice(1, 1);
      }
      // 获取发票状态列表填充单元格
      this.invStatusList = codeListFacade.getSelectOptions("发票状态","发票状态");
    },
    //解析企业信息
    parseEntInfo(res) {
      this.pageLoading = false;
      let entList = [{ text: "受票方", value: "" }];
      let accEntList = [];
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          entList.push(ent);
          accEntList.push(ent);
        });
      }

      this.entList = entList;
      this.accEntList = accEntList;
      if (this.accEntList.length > 0) {
        this.accountParam.entCode = this.accEntList[0].value;
      }
    },
    // 获取票种的简称
    getInvTypeName(code) {
      switch (code) {
        case "01":
          return "纸专";
        case "04":
          return "纸普";
        case "10":
          return "电普";
        case "20":
          return "电专";
        case "31":
          return "全电专";
        case "32":
          return "全电普";
        case "81":
          return "纸票专";
        case "82":
          return "纸票普";
        case "51":
          return "火车";
        case "61":
          return "飞机";
        default:
          return "未知";
      }
    }
  }
};
</script>

<style >
.time-collected-width {
  min-width: 120px;
}
.actions {
  width: 150px;
}
.blank {
  width: 150px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
</style>
